// @flow

import { isClosed } from '@flow/libs/agreement/states';
import * as AGREEMENT_CONSTANTS from '@flow/libs/agreement/participant/constants';

export const getAvailableCreatorRules = (agreement) => {
  const availableCreatorRules = [
  ];
  if (!isClosed(agreement)) {
    availableCreatorRules.push(AGREEMENT_CONSTANTS.TYPE_IS_SIGNATORY);
    availableCreatorRules.push(AGREEMENT_CONSTANTS.TYPE_IS_INFLUENCER);
  }
  availableCreatorRules.push(AGREEMENT_CONSTANTS.TYPE_IS_ORGANIZER);
  return availableCreatorRules;
};
